<div fxLayout="row" fxLayout.lt-md="column" fxLayoutAlign="end center" fxLayoutAlign.lt-md="center end"
  fxLayoutGap.gt-sm="4px" ngClass.gt-sm="layout padding-right-md" ngClass.lt-md="mr4">
  <span class="app-bar-contact-question">Questions? </span>
  <span fxHide.lt-md class="app-bar-contact-question">Give us a call at</span>
  <span class="app-bar-contact-number"><a href="tel:{{contactPhone}}">{{contactPhone}}</a></span>
</div>
